import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { IconType } from '@tools/ui/dime';
import { userStore } from '@tools/ui-stores';
import ActionUserProfile from './ActionUserProfile.component';

const LogoutButton = styled(Button)`
  padding: 0;
  width: 100%;
`;

const FooterUserProfile: React.FC<React.PropsWithChildren> = () => {
  const { t } = useTranslation();

  const signOut = (): void => {
    userStore.signOut();
  };

  return (
    <LogoutButton type="link" onClick={signOut}>
      <ActionUserProfile text={t('sideContainer.actions.logout')} icon={IconType.LogOut} />
    </LogoutButton>
  );
};

export default FooterUserProfile;
